module.exports = __webpack_public_path__ + "static/media/zr_2_15.ba7c9a81.png";